import React from 'react';
import { formatDate } from 'pano-utils';
import { useStore } from 'effector-react';
import { LibDateTypeGate } from '../stores/libState';

type Props = {
  date: number;
  createDate?: number;
};

function LibItemDate({ date, createDate }: Props) {
  const dateType = useStore(LibDateTypeGate.state);
  const text =
    dateType === 'createDate' && createDate
      ? formatDate(createDate)
      : formatDate(date);
  return <div className="shrink-0 text-black-gray">{text}</div>;
}

export default LibItemDate;
